/**
 * AppClipExitScreen - Displayed when user exits AR in App Clip mode
 * 
 * Shows a message indicating the user can close the app.
 */

interface AppClipExitScreenProps {
  /** Custom message to display. Defaults to "You can now close this App Clip" */
  message?: string;
  /** Custom className for the container */
  className?: string;
  /** Custom inline styles */
  style?: React.CSSProperties;
}

export function AppClipExitScreen({ 
  message = "You can now close this App Clip",
  className,
  style,
}: AppClipExitScreenProps) {
  return (
    <div 
      className={className}
      style={{
        position: 'fixed',
        top: 0, 
        left: 0, 
        right: 0, 
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#1a1a1e',
        zIndex: 100,
        ...style,
      }}
    >
      <p style={{
        color: 'white',
        fontSize: '20px',
        fontWeight: 500,
        textAlign: 'center',
        padding: '24px',
        margin: 0,
      }}>
        {message}
      </p>
    </div>
  );
}
